import React, { Component } from 'react';
import TableSemantic from './table_semantic.js';
import { Icon, Modal, Button } from 'semantic-ui-react';

export default class ButtonAllHistory extends React.Component {
	
	constructor(props) {
		
		super(props);
		
		this.state = {
			modalOpen: false,
		};
		
		this.handleClose = this.handleClose.bind(this);
		this.click = this.click.bind(this);
	}
	
	componentDidMount() {
		
		window["ButtonAllHistoryModalOpen"] = () => {
			
			this.setState({ modalOpen: true });
		};
	}
	
	handleClose = () => this.setState({ loading: false, modalOpen: false })
	
	click(e) {
		
		const code = parseInt(GetAttributeFromEvent(e, "code"));
		
		history.pushState({ history: code }, null, "/history/" + code);
		
		this.setState({ modalOpen: false });
	}
	
	render() {
		
		let { modalOpen, loading } = this.state;
		
		const { click, handleClose } = this;
		
		return (
			<Modal size="large" open={modalOpen} onClose={handleClose} className="no-print">
				<Modal.Header><Icon name='history' /> {text.history}</Modal.Header>
				<Modal.Content scrolling>
					<Modal.Description>
						<TableSemantic click={click} linesPerPage={5} />
					</Modal.Description>
				</Modal.Content>
				<Modal.Actions>
					<Button fluid onClick={handleClose}
						style={{ width: "calc(100% - 14px)", marginLeft: "7px" }}
					>
						<Icon name="times circle" /> {text.close}
					</Button>
				</Modal.Actions>
			</Modal>
		);
	}
}